var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBreadcrumb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.065,
    height: 15.489,
    viewBox: "0 0 19.065 15.489",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-menu",
    "data-name": "Icon ionic-ios-menu",
    transform: "translate(-4.5 -10.125)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49478",
    "data-name": "Path 49478",
    d: "M22.771,12.338H5.294c-.437,0-.794-.5-.794-1.106h0c0-.608.357-1.106.794-1.106H22.771c.437,0,.794.5.794,1.106h0C23.565,11.84,23.208,12.338,22.771,12.338Z",
    fill: "#bcbcbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49479",
    "data-name": "Path 49479",
    d: "M22.771,19.088H5.294c-.437,0-.794-.5-.794-1.106h0c0-.608.357-1.106.794-1.106H22.771c.437,0,.794.5.794,1.106h0C23.565,18.59,23.208,19.088,22.771,19.088Z",
    transform: "translate(0 -0.112)",
    fill: "#bcbcbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49480",
    "data-name": "Path 49480",
    d: "M22.771,25.838H5.294c-.437,0-.794-.5-.794-1.106h0c0-.608.357-1.106.794-1.106H22.771c.437,0,.794.5.794,1.106h0C23.565,25.34,23.208,25.838,22.771,25.838Z",
    transform: "translate(0 -0.224)",
    fill: "#bcbcbc"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreadcrumb);
export default __webpack_public_path__ + "static/media/Breadcrumb.b16661c5abd19c9217d46dd2cdbf2579.svg";
export { ForwardRef as ReactComponent };